<template>
  <div>
    <span class="bg" id="bgImage"></span>
    <v-app-bar
      absolute
      :color='barTransparent'
      :src='backgroundSRC'
      elevation="0"
      style="opacity: 0" 
      class="animated"
      v-bind:class="{ fadeIn: show }"
    >
      <v-container class="py-0 fill-height">
        <v-spacer></v-spacer>
        <v-app-bar-title v-if="theme == 'cure'">

            <div class="mt-0" style="fill:white;"><svg class="InlineSVG Icon Icon--sm" viewBox="0 0 78 17" focusable="false" width="125" height="50" role="img" aria-labelledby="stripe-title"><title id="stripe-title">CURE Pay</title><g fill-rule="evenodd"><path class="cls-1" d="M5.26,3.9c1.92,0,4.23.67,4.23,2.44V7.87H6.75V7.29c0-.46-.62-.71-1.36-.71A2,2,0,0,0,3.24,8.84a2.25,2.25,0,0,0,2.43,2.44,4.89,4.89,0,0,0,2.88-1.06l1.09,2.25a6.43,6.43,0,0,1-4.18,1.47C2.61,13.94,0,12.08,0,9A5,5,0,0,1,5.26,3.9Z"/><path class="cls-1" d="M11.79,6.45h-1.3V4.12H15V9.84c0,.9.35,1.27,1.06,1.27,1.27,0,2-1.47,2-2.92V6.45H16.77V4.12H21.3V11a.37.37,0,0,0,.41.41h.8v2.33h-3c-.88,0-1.33-.43-1.33-1.08v-.26a2.5,2.5,0,0,1,0-.28h0a3.5,3.5,0,0,1-3.27,1.84c-1.69,0-3.15-.89-3.15-3.59Z"/><path class="cls-1" d="M23.76,11.39h1.3V6.86a.37.37,0,0,0-.41-.41h-.89V4.12h3c.88,0,1.36.36,1.36,1.23v.51a3.4,3.4,0,0,1,0,.48h0A3.35,3.35,0,0,1,31.21,4a1.94,1.94,0,0,1,.37,0V7.16a3.18,3.18,0,0,0-.65-.06c-1.79,0-2.65,1.14-2.65,2.89v1.4h1.31v2.33H23.76Z"/><path class="cls-1" d="M37.36,3.9c2.87,0,4.47,2,4.47,4.64,0,.32-.07,1-.07,1h-6.1a2.14,2.14,0,0,0,2.24,1.77,5.33,5.33,0,0,0,2.7-.91l1.18,2.23a6.7,6.7,0,0,1-4.14,1.34,5,5,0,0,1-5.28-5A4.78,4.78,0,0,1,37.36,3.9ZM38.5,7.74a1.32,1.32,0,0,0-1.22-1.42,1.56,1.56,0,0,0-1.54,1.42Z"/><path class="cls-1" d="M61.06,6.1H61a5.87,5.87,0,0,1-.19,1l-.51,1.77h1.44l-.5-1.77A5.87,5.87,0,0,1,61.06,6.1Z"/><path class="cls-1" d="M53.56,6.22A1.44,1.44,0,0,0,52.72,6H51.66V8.74h1a1.61,1.61,0,0,0,.84-.2A1.34,1.34,0,0,0,54,7.36,1.33,1.33,0,0,0,53.56,6.22Z"/><path class="cls-1" d="M74.83,0H47.72A3.33,3.33,0,0,0,44.4,3.32V14.53a3.33,3.33,0,0,0,3.32,3.31H74.83a3.32,3.32,0,0,0,3.31-3.31V3.32A3.32,3.32,0,0,0,74.83,0ZM54.53,10.42a4.72,4.72,0,0,1-1.51.2H51.66V12h1.07v1.75H48.18V12h1.07V5.87H48.18V4.12H53a4.52,4.52,0,0,1,1.61.22,3.09,3.09,0,0,1,1.85,3A3.13,3.13,0,0,1,54.53,10.42Zm11.28,3.3h-4V12h.83l-.36-1.27H59.8L59.44,12h.83v1.75h-4V12h.79l2.62-7.85H62.4L65,12h.79Zm8.31-7.85H73.3L71,9.79V12H72v1.75H67.47V12h1.08V9.79L66.2,5.87h-.82V4.12h4V5.87h-.8l1,1.77a4,4,0,0,1,.21.47h0A4,4,0,0,1,70,7.64l1-1.77h-.8V4.12h4Z"/></g></svg></div>

        </v-app-bar-title>
        <v-app-bar-title v-else>

            <img
                src="/img/alpha-logo.png"
                height="50"
                width="auto"
                alt="CURE Token Logo"
                style="display: block; margin:auto; margin-top:10px; top:0px; position: relative;"

              />

        </v-app-bar-title>
        <v-spacer></v-spacer>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              icon
              v-on="on"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-list dense>
              <v-list-item link v-if="$auth.isAuthenticated" @click="logout">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

          </v-card>
        </v-menu>
      </v-container>
    </v-app-bar>
    <v-dialog
      v-model="transferAlert"
      persistent
      max-width="500"
    >
      <v-card class="pa-4">
        <v-card-title class="text-h5">
          Sure, we can help you with that.
        </v-card-title>
        <v-card-text>Please reach out to <a href='mailto:support@curetoken.net'>support@curetoken.net</a> to request support on how to sell your tokens. Alternatively, you can request your private keys from the Pro Features Mode and import them into a software wallet of your choice.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            :color="primaryColor"
            large
            @click="transferAlert = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="requestProFeatures"
      max-width="500px"
      class="pa-8"
    >
      <v-card class="pa-8">
        <v-card-text class="pa-0">
          <v-row class="">
            <v-col sm="12" cols="12" class="pa-8">
              <h2>
                Request With KYC
              </h2>
              <h4 class="mb-4">
                Approximately 24 Hours. If needed, the CURE Pay team will reach out for additional KYC materials.
              </h4>
              <p>This feature will allow you to transfer your tokens to a software wallet of your choice. You can enable this feature by completing a KYC that requires you to provide your ID for validation.</p>
              <v-btn
                :color="primaryColor"
                class="white--text"
                elevation="0"
                block
                large
                @click="request_kyc()"
              >
                Perform KYC <!--Perform KYC -->
              </v-btn>
            </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="buyWidget"
      max-width="490"
      
      v-if="buyWidget"
    >
      <v-card fill-height style="border-radius: 20px;" id="buyWidget">
        <Widget :clientID="curToken" :user="user" :email="email" :embedded="true" />
      </v-card>
    </v-dialog>

    

    <v-container v-bind:style="{ margin: themeHeight}">
    <v-row justify="center" >
      <v-col sm="4" cols="12">
        <v-row justify="center">
          <v-fade-transition>
            <v-sheet
              rounded
              width="100%"
              elevation="20"
              style="padding:20px; opacity: 0; position: relative;"
              class="mb-4 mx-4 animated fadeIn"
            > 
              <v-progress-circular
                :size="40"
                :width="5"
                color="grey lighten-3"
                indeterminate
                class="mb-4 mx-4 animated loader"
                v-bind:class="{ fadeOut: show }"
              ></v-progress-circular>
                <div style="opacity: 0" class="animated" v-bind:class="{ fadeIn: show }" >

                  <v-list-item class="mb-4 ma-0 pa-0">
                    <v-badge
                      avatar
                      bordered
                      overlap
                      bottom
                      offset-x="18"
                      offset-y="18"
                      icon="mdi-check"
                      color="blue" 
                      v-if="proMode"
                    >
                      <v-avatar
                        :color="primaryColor" 
                        size="65"
                        class="profile-picture white--text"
                      >
                        <h1>{{ user.initials }}</h1>
                      </v-avatar>
                    </v-badge>
                    <v-avatar
                      :color="primaryColor" 
                      size="65"
                      class="profile-picture white--text"
                      v-else
                    >
                      <h1>{{ user.initials }}</h1>
                    </v-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle>
                          <div class="ma-4">
                            <h2 style="font-size: 1.75em; line-height: 1em;" class="grey--text text--darken-1">
                              <span v-if="toggleState">{{ user.fullname }}</span>
                              <span v-else>&#65121;&#65121;&#65121; &#65121;&#65121;&#65121;</span>
                              <v-btn
                                class="mx-2"
                                icon
                                dark
                                small
                                style="float:right;"
                                color="grey lighten-1"
                                @click="toggleDetails()"
                              >
                                <v-icon dark v-if="toggleState">
                                  mdi-eye-off
                                </v-icon>
                                <v-icon dark v-else>
                                  mdi-eye
                                </v-icon>
                              </v-btn>
                            </h2>
                            <p class="grey--text text--darken-1 text-wrap caption">
                              <span v-if="toggleState">{{ shortenLength(email) }}</span>
                              <span v-else>&#65121;&#65121;&#65121;&#65121;@&#65121;&#65121;&#65121;.&#65121;&#65121;&#65121;</span>
                            </p>
                          </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider></v-divider>
              
                  <v-list-item class="my-4">
                    <v-list-item-content style="text-align: center;">
                      <v-list-item-title class="grey--text text--darken-1">
                        APPROXIMATE PORTFOLIO VALUE
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <h1 v-bind:style="{ color: primaryColor }" class='font-weight-light'>
                          <span v-if="toggleState">${{ (totalValue) }}</span>
                          <span v-else>&#65121;&#65121;.&#65121;&#65121;</span>
                        </h1>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider v-if="!proMode"></v-divider>

                  <div v-if="!proMode">
                    <v-list-item class="">
                      <v-list-item-content style="text-align: center;" class="py-4">
                        <v-list-item-subtitle>
                          <v-btn
                            class="white--text"
                            color="grey"
                            large
                            block
                            elevation="0"
                            :disabled="kycButtonDisabled"
                            @click="requestProFeatures = true"
                          >
                            <v-icon left>
                              mdi-check-decagram
                            </v-icon>
                            {{ kycButtonText }}
                          </v-btn>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                  </div>

              </div>
            </v-sheet>
          </v-fade-transition>
        </v-row>



        <v-row justify="center" v-if="recoProjects.length > 1">
          <v-fade-transition>
            <v-sheet
              rounded
              width="100%"
              elevation="20"
              style="padding:20px; opacity: 0; position: relative;"
              class="mb-4 mx-4 animated fadeIn"
            > 
              <v-progress-circular
                :size="40"
                :width="5"
                color="grey lighten-3"
                indeterminate
                class="mb-4 mx-4 animated loader"
                v-bind:class="{ fadeOut: show }"
              ></v-progress-circular>
              <div class="grey--text text--darken-1" >
                <h4 class="mb-6 text-center">PROJECT ECOSYSTEM</h4>

                <v-row align="center" justify="center">
                  <v-col
                    v-for="(image, n) in mainProjects"
                    :key="n"
                    class="d-flex child-flex"
                    cols="4"
                  >
                    <v-img
                      :src="mainProjects[n][2]"
                      aspect-ratio="1"
                      contain
                      class="hand"
                      @click="buyModal(mainProjects[n][1])"
                    />
                  </v-col>
                </v-row>

                <v-row align="center" justify="center">
                  <v-col
                    v-for="(image, n) in recoProjects"
                    :key="n"
                    class="d-flex child-flex"
                    cols="3"
                  >
                    <v-img
                      :src="recoProjects[n][2]"
                      aspect-ratio="1"
                      contain
                      class="hand"
                      @click="buyModal(recoProjects[n][1])"
                    />
                  </v-col>
                </v-row>

              </div>
            </v-sheet>
          </v-fade-transition>
        </v-row>


      </v-col>
      <v-col sm="8" cols="12" class="">
        <v-row justify="center">
          <v-sheet
            rounded
            width="100%"
            elevation="20"
            style="padding:20px; opacity: 0; position: relative;"
            class="mx-4 animated fadeIn"
          >
            <v-progress-circular
              :size="40"
              :width="5"
              color="grey lighten-3"
              indeterminate
              class="mb-4 mx-4 animated loader"
              v-bind:class="{ fadeOut: show }"
            ></v-progress-circular>
            <div style="opacity: 0" class="animated" v-bind:class="{ fadeIn: show }">
              <v-card
                class="mx-auto"
                transparent
                elevation="0"
                style="min-height:50px;"
              >
                <!--<v-container v-if="!proMode">
                  <v-row justify="end" class="mb-2">
                    <v-btn
                      class="white--text"
                      color="grey"
                      small
                      elevation="0"
                      :disabled="kycButtonDisabled"
                      @click="requestProFeatures = true"
                    >
                      <v-icon left>
                        mdi-check-decagram
                      </v-icon>
                      {{ kycButtonText }}
                    </v-btn>
                  </v-row> 
                </v-container>
                <v-divider class="mb-4" v-if="!proMode"></v-divider>-->
                <v-card-title class='mb-4'>
                  <v-row align="start">

                    <div class="text-caption grey--text text-uppercase">
                      <p class="grey--text text--darken-1 ml-1 mb-0">{{projectName}} Current Price
                        <span class="" v-if="difference.includes('-')">
                          <span
                            v-text="difference || '-'"
                            class="red--text"
                          ></span>
                          <v-icon small class="red--text">mdi-menu-down</v-icon>
                        </span>
                        <span class="" v-else>
                          <span
                            v-text="difference || '-'"
                            class="green--text"
                          ></span>
                          <v-icon small class="green--text">mdi-menu-up</v-icon>
                        </span>
                      </p>
                      <span
                        v-bind:style="{ color: primaryColor }"
                        class="text-h4 font-weight-light mt-0"
                        v-text="currentPrice || '—'"
                      ></span>
                    </div>
                    <v-spacer></v-spacer>
                    <span class="text-caption grey--text text-uppercase text-right">
                      <span class="d-block red--text">LOW: {{ minNum.toFixed(9) }} </span>
                      <span style="line-height:.9em" class="d-block green--text">HIGH: {{ maxNum.toFixed(9) }}</span>
                    </span>
                  </v-row>
                </v-card-title>

                <v-sheet color="transparent" v-if="!$vuetify.breakpoint.smAndDown">
                  <div class="animated fadeIn" v-if="value.length > 1">
                    <v-sparkline
                      :value="value"
                      :gradient="gradient"
                      :smooth="radius || false"
                      :padding="padding"
                      :line-width="width"
                      :stroke-linecap="lineCap"
                      :gradient-direction="gradientDirection"
                      :type="type"
                      :auto-line-width="autoLineWidth"
                      auto-draw
                      :height="sparkHeight"
                      color="grey"
                      ref="sparkline"
                    >
                      <template v-slot:label="item">
                        {{ Number(item.value).toFixed(4) }}
                      </template>
                    </v-sparkline>
                  </div>
                  <div 
                    v-else
                    align="center"
                    justify="center"
                    :height="sparkHeight"
                    fill-height
                    v-bind:style="{ margin: chartMargin }"
                  >
                    <span style="color:#cccccc">NO CHART DATA AVAILABLE</span>
                  </div>

                </v-sheet>
              </v-card>
              
              
              <div>

                <v-tabs
                  :background-color="primaryColor"
                  dark
                  class="mt-4"
                  v-model="tab"
                  v-if="!$vuetify.breakpoint.smAndDown"
                >
                  <v-tab class="tab" href="#summary">
                    TOKEN SUMMARY
                  </v-tab>
                  <v-tab class="tab" href="#purchase">
                    PURCHASE HISTORY
                  </v-tab>
                  <v-tab class="tab" href="#transfer">
                    TRANSFER HISTORY
                  </v-tab>

                  <v-tabs-items v-model="tab" touchless>
                    <v-tab-item value="summary" transition="fade-transition" touchless>
                      <Summary v-if="tab == 'summary'" :primaryColor="primaryColor" :user="user" @projects="storeProjects($event)" :email="email" @buyModal="buyModal($event)" @loadChart="loadChart($event)" @refresh="refreshData($event)" @requestProFeaturesEmit="requestProFeaturesEmit($event)" :proMode="proMode" />
                    </v-tab-item>
                    <v-tab-item value="purchase" transition="fade-transition" touchless>
                      <Purchase v-if="tab == 'purchase'" :primaryColor="primaryColor" :email="email"  />
                    </v-tab-item>
                    <v-tab-item value="transfer" transition="fade-transition" touchless>
                      <Transfer v-if="tab == 'transfer'" :primaryColor="primaryColor" :email="email" :proMode="proMode" />
                    </v-tab-item>
                  </v-tabs-items>

                </v-tabs>
                
                <v-expansion-panels accordion multiple v-model="panel" v-if="$vuetify.breakpoint.smAndDown">
                  <v-expansion-panel expand v-model="panel">
                    <v-expansion-panel-header :color="primaryColor" class="white--text">TOKEN SUMMARY<template v-slot:actions><v-icon color="white">$expand</v-icon></template></v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <Summary :primaryColor="primaryColor" :user="user" :email="email" @projects="storeProjects($event)" @buyModal="buyModal($event)" @loadChart="loadChart($event)" @refresh="refreshData($event)" :proMode="proMode" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel v-model="panel">
                    <v-expansion-panel-header :color="primaryColor" class="white--text">PURCHASE HISTORY<template v-slot:actions><v-icon color="white">$expand</v-icon></template></v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <Purchase :primaryColor="primaryColor" :email="email"  />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel v-model="panel">
                    <v-expansion-panel-header :color="primaryColor" class="white--text">TRANSFER HISTORY<template v-slot:actions><v-icon color="white">$expand</v-icon></template></v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <Transfer :primaryColor="primaryColor" :email="email" :proMode="proMode" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

            </div>
            
          </v-sheet>
          <v-footer color="transparent" style="height:90px;">
            <v-col
              class="text-center"
              cols="12"

            >
              <div v-if="theme == 'cure'" class="Footer-PoweredBy mt-0"><a class="Link Link--primary" href="https://curetoken.net" target="_blank" rel="noopener"><span class="grey--text">Powered by <svg class="InlineSVG Icon Footer-PoweredBy-Icon Icon--md" focusable="false" width="33" height="10" role="img" aria-labelledby="stripe-title" style="fill:grey;"><title id="stripe-title">CURE</title><g fill-rule="evenodd"><path class="cls-1" d="M4.26,5.55A1.68,1.68,0,0,1,2.44,3.71,1.49,1.49,0,0,1,4.05,2c.56,0,1,.18,1,.53V3H7.13V1.83C7.13.5,5.39,0,4,0A3.79,3.79,0,0,0,0,3.8,3.83,3.83,0,0,0,4.1,7.55,4.8,4.8,0,0,0,7.24,6.44L6.43,4.75A3.67,3.67,0,0,1,4.26,5.55Z"/><path class="cls-1" d="M16,5.32V.17H12.6V1.92h1v1.3c0,1.09-.54,2.2-1.5,2.2-.53,0-.79-.28-.79-1V.17H7.88V1.92h1V4.85c0,2,1.1,2.7,2.37,2.7a2.61,2.61,0,0,0,2.45-1.39h0s0,.12,0,.21v.2c0,.49.33.81,1,.81h2.23V5.63h-.61A.28.28,0,0,1,16,5.32Z"/><path class="cls-1" d="M21.16,1.83h0a1.89,1.89,0,0,0,0-.36V1.09c0-.66-.37-.92-1-.92H17.85V1.92h.67a.28.28,0,0,1,.31.31v3.4h-1V7.38h4.38V5.63h-1v-1c0-1.32.65-2.17,2-2.17a2.62,2.62,0,0,1,.49,0V.07a1.53,1.53,0,0,0-.28,0A2.48,2.48,0,0,0,21.16,1.83Z"/><path class="cls-1" d="M28.48,5.55A1.61,1.61,0,0,1,26.8,4.22h4.58s.05-.49.05-.73A3.2,3.2,0,0,0,28.07,0a3.59,3.59,0,0,0-3.75,3.77,3.73,3.73,0,0,0,4,3.78,5,5,0,0,0,3.11-1l-.88-1.68A4,4,0,0,1,28.48,5.55ZM28,1.82a1,1,0,0,1,.91,1.07H26.85A1.19,1.19,0,0,1,28,1.82Z"/></g></svg></span></a></div>

              <div v-if="theme == 'alpha'" class="Footer-PoweredBy mt-0"><span class="grey--text">Powered by <svg class="InlineSVG Icon Footer-PoweredBy-Icon Icon--md" focusable="false" width="120" height="14" role="img" aria-labelledby="stripe-title" style="fill:grey;"><title id="stripe-title">CURE</title><g fill-rule="evenodd"><path class="cls-1" d="M4,3.87c1.64,0,3.38.54,3.38,1.93V7.09H5V6.68c0-.26-.27-.4-.8-.4-1,0-1.23.63-1.23,1.3a1.35,1.35,0,0,0,1.5,1.5,3.41,3.41,0,0,0,2.13-.75l1,2a4.87,4.87,0,0,1-3.28,1.1C2,11.47,0,10.09,0,7.69A3.85,3.85,0,0,1,4,3.87Z"/><path class="cls-1" d="M13.53,6.11h-.89V4h3.81V8.91a.29.29,0,0,0,.31.31h.53V11.3H14.72c-.69,0-1.05-.3-1.05-.89,0-.17,0-.35,0-.35h0a2.33,2.33,0,0,1-2.31,1.41c-1.21,0-2.43-.6-2.43-2.69V6.11H8.05V4h3.81V8.26c0,.49.17.66.53.66.77,0,1.14-.84,1.14-1.76Z"/><path class="cls-1" d="M18.12,9.23h.93V6.42a.28.28,0,0,0-.3-.31h-.58V4h2.61c.67,0,1.08.27,1.08,1v.35a1.3,1.3,0,0,1,0,.31h0a2.53,2.53,0,0,1,2.31-1.77l.25,0V6.78a3.12,3.12,0,0,0-.53,0c-1.28,0-1.91.54-1.91,1.82v.67h.94V11.3h-4.8Z"/><path class="cls-1" d="M28.67,3.87A3.3,3.3,0,0,1,32.2,7.31a7.15,7.15,0,0,1-.05.8H27.81a1.29,1.29,0,0,0,1.37,1,4.54,4.54,0,0,0,2-.63l1,2a5.39,5.39,0,0,1-3.24,1,3.78,3.78,0,0,1-4.09-3.86A3.64,3.64,0,0,1,28.67,3.87Zm.54,3c0-.49-.12-1-.63-1s-.69.74-.72,1Z"/><path class="cls-1" d="M40.54,0h2.4V13.66h-2.4Z"/><path class="cls-1" d="M51.1,9.15h.76l2.53-7.92h3.46l2.54,7.92h.77V11.3H56.6V9.15h.79l-.2-.93H55.05l-.2.93h.79V11.3H51.1Zm5.63-2.92-.32-1.38c-.17-.75-.25-1.35-.25-1.35h-.07a10.81,10.81,0,0,1-.26,1.35L55.5,6.23Z"/><path class="cls-1" d="M62,3.31h-.89V1.23H64.9v7c0,.72.12.88.64.88h.25v2.3a7.75,7.75,0,0,1-.79,0c-1.41,0-3-.27-3-3.06Z"/><path class="cls-1" d="M67.35,12V6.42a.28.28,0,0,0-.3-.31h-.58V4H69c.58,0,1,.17,1,.69a1,1,0,0,1,0,.14h0a2.63,2.63,0,0,1,2.17-1c1.88,0,3.25,1.55,3.25,3.78s-1.5,3.82-3.35,3.82a2.61,2.61,0,0,1-1.76-.6h0a3.75,3.75,0,0,1,0,.55V12h.82v2.08H66.54V12Zm3.94-2.95c.64,0,1.15-.48,1.15-1.36S72,6.3,71.32,6.3s-1.14.45-1.14,1.38C70.18,8.4,70.53,9.08,71.29,9.08Z"/><path class="cls-1" d="M76.06,9.23h.81V3.31H76V1.23H79.8v3.1a4.4,4.4,0,0,1,0,.63h0a2.58,2.58,0,0,1,4.68,1.6V9.23h.81V11.3H81.54V7.13c0-.49-.18-.63-.55-.63-.91,0-1.19.85-1.19,1.67V9.23h.81V11.3H76.06Z"/><path class="cls-1" d="M89.49,6.91h.42V6.58c0-.33-.39-.46-.79-.46a4.44,4.44,0,0,0-2,.69l-1-2a5.85,5.85,0,0,1,3.31-1c2.11,0,3.36,1.09,3.36,3v2a.29.29,0,0,0,.31.31h.44V11.3H91.2a.92.92,0,0,1-1-.89v0a.8.8,0,0,1,0-.11h0a2.29,2.29,0,0,1-2.06,1.15,2.2,2.2,0,0,1-2.34-2.14C85.78,7.2,88.4,6.91,89.49,6.91Zm-.41,2.62a1,1,0,0,0,.87-1V8.21h-.17c-.88,0-1.19.42-1.19.8A.48.48,0,0,0,89.08,9.53Z"/><path class="cls-1" d="M97.79,9.15h.73l2.44-3L98.67,3.39h-.81V1.23h4.51V3.39h-.64l.63.76a4.51,4.51,0,0,1,.35.5h0s.13-.21.35-.5l.61-.76h-.63V1.23h4.23V3.39h-.73l-2.41,2.94,2.35,2.82h.76V11.3h-4.53V9.15h.72l-.7-.84a5.19,5.19,0,0,1-.35-.51h0s-.14.23-.35.51l-.63.84h.67V11.3H97.79Z"/></g></svg></span></div>
            </v-col>
          </v-footer>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>


<script>
import axios from 'axios';
import Summary from './Summary.vue';
import Purchase from './Purchase.vue';
import Transfer from './Transfer.vue';
import Widget from './Widget.vue';
import $ from 'jquery'

export default {
  metaInfo() {
    return {
      title: "CURE Pay",
      meta: [
        {property: 'og:type', content: 'website'},
        {property: 'og:title', content: 'CURE Pay | Dashboard'},
        {property: 'og:url', content: 'https://www.curepayapp.com/dashboard'},
        {property: 'og:description', content: 'Introducing CURE Pay. We handle everything in real-time, so that you don’t have to.'},
        {property: 'og:image', content: '/img/CURE-Pay.png'},
      ]
    };
  },
  watch:{
    proMode(){
      var element = document.getElementById("bgImage");
      //this.changeMode();
    }
  },
  components: {
    Summary,
    Purchase,
    Transfer,
    Widget,
  },
  computed: {
    tokenAmount() {
      return (
        (+this.currentBalance * this.currentPrice)
      ) || 0;
    },
    curePrice(item) {
      return "$"+ this.addDecimal(this.curePriceAtTime.toFixed(6));
    },
    backgroundSRC() {
      let src = '';
      if (this.$route.path === '/') src = '';
      return (src);
    },
    barTransparent(){
      let bgColor = 'transparent';
      if (this.$route.path === '/') bgColor = 'transparent';
      return (bgColor);
    },
    sparkHeight(){
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '140px'
        case 'sm': return '140px'
      }
      return '70px'
    },
    chartMargin(){
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '80px'
        case 'sm': return '80px'
      }
      return '70px'
    }
  },
  methods: {
    storeProjects(projects){
      this.projects = projects;
    },
    toggleDetails(){
      this.toggleState = !this.toggleState;
      return this.toggleState;
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
       return true
      } else {
       return false
      }
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin +"/dashboard",
      });
    },
    changeTheme(){
      //console.log(this.theme);
      //this.primaryColor = '#BDA242';
      if(this.theme == "cure") this.themeHeight = "60px auto"
      $('head').append(`<style id="text-module-style">
        #tableSummary table thead tr th {
          color: ` + this.primaryColor + `;
        }</style>`)

      this.gradient = [this.primaryColor, this.primaryColor, this.primaryColor];

      this.get_projects_by_source(this.email, this.theme);
    },
    changeMode(){
      var element = document.getElementById("bgImage");
      if(this.proMode){
        element.classList.add("grayscale");
        element.classList.remove("no-grayscale");
        //this.set_mode("verified");
      } else {
        element.classList.add("no-grayscale");
        element.classList.remove("grayscale");
        //this.set_mode("standard");
      }
    },
    buy_tokens() {
      this.$router.push('/');
    },
    shortenLength(string) {
      if(window.innerWidth > 1200) {
        return string
      }
      return string.substring(0,25) + "..."
    },
    numberWithCommas(string) {
      if(string == null)  return;
      let partArray = string.split(".");
      if(partArray.length > 1) {
        let leftPart = partArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        let rightPart = partArray[1]
        rightPart = rightPart.substring(0,3);
        return leftPart + "." + rightPart;
      }else{
        return string;
      }      
    },
    addDecimal(string) {
      return string;
    },
    formatDate(dateString) {
      //let dateFormat = new Date(dateString).toUTCString();
      //dateFormat = dateFormat.split(' ').slice(1, 4).join(' ');
      //return dateFormat;
      return dateString;
    },
    async get_user(userEmail) {
    
      const token = await this.$auth.getTokenSilently();
      const path = `${this.$domainPath}/get-user`;
      
      fetch(path, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ email: userEmail }),
      })
        .then((result) => result.json())
        .then((res) => {
          //console.log(res);
          if(this.$router.app.$auth.user['https://pay.curetoken.net/roles'][0] === '_pf') {
            this.proMode = true;
            this.requestedPro = false;
            this.requestProFeatures = false;
          }else{
            if(res['status'] == "none" || res['status'] == "created"){
              this.proMode = false;
              this.requestedPro = false;
              this.requestProFeatures = false;
              this.kycButtonDisabled = false;
            } else if(res['status'] == "processing" || res['status'] == "verified"){
              this.proMode = false;
              this.requestedPro = true;
              this.requestProFeatures = false;
              this.kycButtonDisabled = true;
              this.kycButtonText = "Verification In Progress";
            }
          }

          this.user = res;
          //console.log(res);

          this.theme = 'cure';
          this.primaryColor = '#ff9800';

          for (const key in res["source"]) {
            //console.log(res["source"][key]);

            if(res["source"][key][0] == 'alpha'){
              this.theme = 'alpha';
              this.primaryColor = "#BDA242"; //#BDA242
            }
          }

          this.changeTheme();
          setTimeout(() => { this.show = true; }, 1000);
        });
    },
    async get_chart_data(userEmail, timeframe) {
      const token = await this.$auth.getTokenSilently();
      const path = `${this.$domainPath}/get-chart-data`;
      
      fetch(path, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ email: userEmail, timeframe: timeframe }),
      })
        .then((result) => result.json())
        .then((res) => {
          console.log(res);
          if(res.status != 'error'){
            this.chartData = res.projects[0];
            //this.totalValue = res.value.toFixed(2);
            //setTimeout(() => { this.show = true; }, 1000);
          }
          
        });

      setTimeout(() => { this.show = true; }, 1000);
    },
    async get_project_chart_data(userEmail, project) {
      const token = await this.$auth.getTokenSilently();
      const path = `${this.$domainPath}/get-project-chart-data`;
      
      fetch(path, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ email: userEmail, project: project }),
      })
        .then((result) => result.json())
        .then((res) => {
          //console.log(res);
          if(res.status != 'error'){
            if (res.projects[0][Object.keys(res.projects[0])[0]].data.length > 0) {
              this.maxNum = Math.max(...res.projects[0][Object.keys(res.projects[0])[0]].data);
              this.minNum = Math.min(...res.projects[0][Object.keys(res.projects[0])[0]].data);
              this.difference = res.projects[0][Object.keys(res.projects[0])[0]].difference; 
              this.projectName = Object.keys(res.projects[0])[0];
              this.currentPrice = res.projects[0][Object.keys(res.projects[0])[0]].data[res.projects[0][Object.keys(res.projects[0])[0]].data.length -1].toFixed(10);
              setTimeout(() => { this.value = res.projects[0][Object.keys(res.projects[0])[0]].data; }, 0);
            }else{
              this.maxNum = 0;
              this.minNum = 0;
              this.difference = "0"; 
              this.projectName = Object.keys(res.projects[0])[0];
              this.currentPrice = res.projects[0][Object.keys(res.projects[0])[0]].price;
              setTimeout(() => { this.value = [0] }, 0);
            }
          }
        });
    },
    async get_projects_by_source(userEmail, theme){
      const token = await this.$auth.getTokenSilently();
      const path = `${this.$domainPath}/get-projects-by-source`;
      fetch(path, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ email: userEmail, source: theme }),
      })
        .then((result) => result.json())
        .then((res) => {
          if(res.status != 'error'){
            for (const proj in res) {
              if(res[proj][0] == "CURE" || res[proj][0] == "CHAIN"){
                this.mainProjects.push(res[proj]);
              }else{
                this.recoProjects.push(res[proj]);
              }
            }
          }
        });
    },
    refreshData(evt) {
      console.log('refreshData');
      this.get_chart_data(this.email, "day");
    },
    requestProFeaturesEmit(evt){
      this.requestProFeatures = true;
    },
    buyModal(project) {
      this.curToken = project;
      this.buyWidget = true;
    },
    loadChart(project) {
      //console.log(project);
      this.get_project_chart_data(this.email, project.id);
    },
    getStripePublishableKey() {
      fetch(`${this.$domainPath}/config`)
        .then((result) => result.json())
        .then((data) => {
          this.stripe = Stripe(data.publicKey); // eslint-disable-line no-undef
        });
    },
    async request_kyc() {
      const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
      
      this.requestProFeatures = false;
      this.kycButtonDisabled = true;

      const token = await this.$auth.getTokenSilently();
      const path = `${this.$domainPath}/request-kyc`;
      const t = this;
      fetch(path, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ email: this.email }),
      }).then(function(result) {
        return result.json();
      }).then(function(response) {
        if (response.status == "error") {
          throw response.error;
        } else {
          sessionStorage.setItem('verification_session_id', response.session.id);
          return stripe.verifyIdentity(response.session.client_secret);
        }
      }).then(function(result) {
        if (result.error) {
          t.kycButtonDisabled = false;
          sessionStorage.setItem('verification_session_error', JSON.stringify(result.error));
        } else{
          t.kycButtonText = "Verification In Progress"
          t.kycButtonDisabled = true;
        }
      }).catch(function(error) {
        const errorMessageContainer = document.querySelector('.error-message');
        if (errorMessageContainer) {
          errorMessageContainer.classList.remove('hidden');
        }
      }).finally(function() {
        
      });
      return;
    },
  },
  created() {
    this.getStripePublishableKey();
    this.email = this.$router.app.$auth.user.email;
    this.get_user(this.email);
    if(this.$router.app.$auth.user['https://pay.curetoken.net/roles'][0] === '_pf') {
      this.proMode = true;
    }
  },
  data() {
    return {
      projects:[],
      recoProjects:[],
      mainProjects:[],
      toggleState: true,
      themeHeight: '75px auto',
      primaryColor:null,
      buyWidget: false,
      theme: '',
      chartData: {},
      totalValue: '',
      apiMessage: "",
      minNum: 0,
      maxNum: 0,
      difference: '-',
      projectName: '',
      transferAlert: false,
      width: 3,
      radius: 10,
      padding: 8,
      lineCap: 'round',
      gradient: ['#ffb300', '#ffb300', '#ffb300', '#fe0001',],
      value: [],
      gradientDirection: 'top',
      fill: true,
      type: 'trend',
      autoLineWidth: false,
      show: false,
      currentBalance: 0,
      currentPrice: 0,
      walletAddress: '',
      user: [],
      pkrequests: [],
      userData: [],
      userProjectData: [],
      transferData: [],
      initials: '',
      snackbar: false,
      requestPKSModal: false,
      showKey: true,
      requestedPro: false,
      curePriceAtTime: 0,
      transferForm: false,
      showPrivateKeys: false,
      activeUsers: '0',
      totalTransactions: '0',
      usdYTD: '0',
      cureYTD: '0',
      usdWTD: '0',
      cureWTD: '0',
      proMode: false,
      kycButtonDisabled: false,
      requestProFeatures: false,
      kycButtonText: "Preform KYC",
      stripeId: "",
      nftNumber: "",
      pk: '',
      cards: ['Today', 'Yesterday'],
      drawer: null,
      summary: false,
      purchase: false,
      transfer: false,
      panel: [0],
      links: [
        ['mdi-inbox-arrow-down', 'Inbox'],
        ['mdi-send', 'Send'],
        ['mdi-delete', 'Trash'],
        ['mdi-alert-octagon', 'Spam'],
      ],
      items: [
        { title: 'Home', icon: 'mdi-home-city' },
        { title: 'My Account', icon: 'mdi-account' },
        { title: 'Users', icon: 'mdi-account-group-outline' },
      ],
      tab: null,
      tabitems: [
        { index: 0, name: 'TOKEN SUMMARY', id: 'summary'},
        { index: 1, name: 'PURCHASE HISTORY', id: 'purchase' },
        { index: 2, name: 'TRANSFER HISTORY', id: 'transfer' },
      ],
      active_tab: 2,
      tabs: [
        { index: 0, name: 'tab1' },
        { index: 1, name: 'tab2' },
        { index: 2, name: 'tab3' }
      ]
    };
  },
};
</script>

<style>
  .hand {
    cursor: pointer;
  }
  .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:last-child, .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row), .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:last-child, .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:not(.v-data-table__mobile-row), .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
    border-bottom: 1px dotted #ccc !important;
  }
  .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
    /*padding:  0px;*/
  }
  .Footer-PoweredBy{
    font-size: 12px;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Ubuntu,sans-serif;
  }
  
  .v-slide-group__prev--disabled, .v-slide-group__next--disabled{
    display: none !important;
  }

  .v-tab {
    padding:  0px 10px;
  }

  hr {
    border: 1px dotted #ccc !important;
    border-style: none none dotted !important; 
    color: #fff !important; 
    background-color: #fff !important;

  }
  .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: url( '/img/bg.jpg') no-repeat center center;
    background-size: cover;
    transform: scale(1);
  }
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  .tab{
    color: white !important;
  }

  .summary{
    line-height: 1.5em;
  }
  .truncate {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #transferHolder .v-text-field__slot {
    padding-top:10px !important;
    padding-bottom:10px !important;
  }
  table {
    width: 100%;
  }

  td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .animated {
    background-repeat: no-repeat;
    background-position: left top;
    -webkit-animation-duration: .5s;
    animation-duration: .5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
   
  @-webkit-keyframes fadeIn {
    0% {opacity: 0;}
    100% {opacity: 1;}
  }
   
  @keyframes fadeIn {
    0% {opacity: 0;}
    100% {opacity: 1;}
  }
   
  .fadeIn {
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
  }

  @-webkit-keyframes fadeOut {
    0% {opacity: 1;}
    100% {opacity: 0;}
  }
   
  @keyframes fadeOut {
    0% {opacity: 1;}
    100% {opacity: 0;}
  }
   
  .fadeOut {
    -webkit-animation-name: fadeOut;
    animation-name: fadeOut;
  }

  .loader {
    display: block;
    margin: 0 auto;
    position: absolute;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
  }

  svg > g > text {
    font-size: 0.5em;
  }

  .grayscale {
    filter: grayscale(100%) brightness(.3);
    transition: .5s;
  }

  .no-grayscale {
    filter: grayscale(0%) brightness(1);
    transition: .5s;
  }

  .v-dialog{
    border-radius: 20px !important;
  }

  #buyWidget {
    min-height: 650px !important;
  }

</style>


